module.exports = __webpack_public_path__ + "media/Cinta Luar Biasa - Andmesh Kamaleng (Saxophone Cover by Desmond Amos).4104bfd6.mp3";